import { render, staticRenderFns } from "./block-warning.vue?vue&type=template&id=24ab1084&scoped=true&"
import script from "./block-warning.vue?vue&type=script&lang=js&"
export * from "./block-warning.vue?vue&type=script&lang=js&"
import style0 from "./block-warning.vue?vue&type=style&index=0&id=24ab1084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ab1084",
  null
  
)

export default component.exports